import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const NotFoundPage = () => (
  <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4">
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="text-8xl mb-6">⚡</div>
      <h1 className="text-8xl md:text-9xl font-black text-gray-100 mb-4">404</h1>
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
        Page Not Found
      </h2>
      <p className="text-gray-500 max-w-md mx-auto mb-8 text-lg">
        Looks like this page got lost in transit. Don't worry — our best-selling gadgets are still right where you left them.
      </p>
      <div className="flex flex-wrap justify-center gap-4">
        <Link to="/" className="btn-primary">
          ← Back to Home
        </Link>
        <Link to="/shop" className="btn-secondary">
          Browse Products
        </Link>
      </div>
    </motion.div>
  </div>
);

export default NotFoundPage;
